import { render } from "./IncentiveReward.vue?vue&type=template&id=4b468a02&scoped=true"
import script from "./IncentiveReward.vue?vue&type=script&lang=js"
export * from "./IncentiveReward.vue?vue&type=script&lang=js"

import "./IncentiveReward.vue?vue&type=style&index=0&id=4b468a02&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b468a02"]])

export default __exports__